import { render, staticRenderFns } from "./WrhDashboard.vue?vue&type=template&id=91220206&"
import script from "./WrhDashboard.vue?vue&type=script&lang=js&"
export * from "./WrhDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports